import React, { useEffect, useRef, useState } from 'react';

/**
 * The sideways scroller of a wide table (`.ui-table-scroll`). While there is more table to the
 * right of what shows, the right edge fades (`.fade-x-end`), so a last column is never clipped
 * without a cue. The fade is gone once the end is reached or when the table fits.
 */
function TableScroll({ children, className = '' }) {
  const ref = useRef(null);
  const [more, setMore] = useState(false);

  useEffect(() => {
    const box = ref.current;
    if (!box) return undefined;
    const measure = () => setMore(box.scrollWidth - box.clientWidth - box.scrollLeft > 2);
    measure();
    box.addEventListener('scroll', measure, { passive: true });
    window.addEventListener('resize', measure);
    let observer = null;
    if (typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(measure);
      observer.observe(box);
      if (box.firstElementChild) observer.observe(box.firstElementChild);
    }
    return () => {
      box.removeEventListener('scroll', measure);
      window.removeEventListener('resize', measure);
      if (observer) observer.disconnect();
    };
  }, []);

  return (
    <div ref={ref} className={`ui-table-scroll ${more ? 'fade-x-end' : ''} ${className}`.trim()}>
      {children}
    </div>
  );
}

export default TableScroll;
